import { render, staticRenderFns } from "./VerticalAlignmentField.vue?vue&type=template&id=69289b4c"
import script from "./VerticalAlignmentField.vue?vue&type=script&lang=js"
export * from "./VerticalAlignmentField.vue?vue&type=script&lang=js"
import style0 from "./VerticalAlignmentField.vue?vue&type=style&index=0&id=69289b4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports